import { render, staticRenderFns } from "./TypeButtons.vue?vue&type=template&id=1b892e28&"
import script from "./TypeButtons.vue?vue&type=script&lang=js&"
export * from "./TypeButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports